<xi-drawer
  #drawer
  *transloco="let t; read: 'configuration-routes.create'"
  [open]="open"
  [interceptClose]="true"
  (onClose)="cancel()"
  color="CX"
  [silverBg]="true"
>
  <div slot="title">{{ t('title') }}</div>
  <div slot="body">
    @if (isSaving) {
      <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }

    <app-configuration-route-details-form
      [(name)]="configurationRoute.name"
      [(notes)]="configurationRoute.notes"
      [nameValidator]="nameValidator"
      (validityChange)="isNameValid = $event"
      [canEditRoute]="canEditRoute"
    ></app-configuration-route-details-form>

    <div class="create-configuration-route-drawer__included-configs-form">
      <h3>{{ t('configurations-header') }}</h3>

      <p>{{ t('configurations-content') }}</p>

      <app-included-configurations-form
        [configurationRoute]="configurationRoute"
        (includedConfigurationsChange)="onIncludedConfigurationsChanged($event)"
      ></app-included-configurations-form>
    </div>

    <div class="create-configuration-route-drawer__default-language-form">
      <div class="xi-form-group__side--left">
        <h3>{{ t('language-header') }}</h3>

        <p>{{ t('language-content') }}</p>
      </div>

      <div class="xi-form-group__side--right">
        <xi-dropdown
          [placeholder]="t('language-placeholder')"
          [localization]="{ noResultsFound: t('no-results-found') }"
          [label]="t('language')"
          [value]="configurationRoute.default_language_id"
          [data]="defaultLanguages"
          [stretch]="true"
          (onValueChange)="configurationRoute.default_language_id = $event.detail.selected.id"
        ></xi-dropdown>
      </div>
    </div>

    <app-response-type-form
      [canEditRoute]="canEditRoute"
      [(responseType)]="configurationRoute.response_type"
      [(callbackUrl)]="configurationRoute.callback_url"
      (validityChange)="isResponseTypeValid = $event"
    ></app-response-type-form>
  </div>

  <div slot="footer" class="create-configuration-route-drawer__actions">
    <xi-default-button
      [text]="t('cancel')"
      fill="text"
      [disabled]="isSaving"
      (onClick)="cancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="t('save')"
        [disabled]="!isValid"
        (onClick)="save()"
      ></xi-default-button>

      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</xi-drawer>
